/* eslint-disable import/no-cycle */
import { makeServiceCall } from 'redux-core/serviceHelpers';

export const getProjectWithProductions = makeServiceCall('projects', 'get-all');
